import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobile: false // 判断是否是移动端
  },
  mutations: {
    setIsMobile(state, isMobile) {
      state.isMobile = isMobile
    }
  },
  actions: {},
  modules: {}
})
